export enum ModoPaginaEnum {
    Edicao = 0,
    Visualizacao = 1
}